export default __webpack_public_path__ + "static/media/icon-info.98bc09f8.svg";